import React, { useEffect } from 'react'
import Button from '@/components/UiElements/Button'
import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import animateTo from '@/components/ProductProfile/utils/animateTo'
import zoomToFrameSection from '@/components/ProductProfile/utils/zoomToFrameSection'
import getThumbnail from '@/components/ProductProfile/utils/getThumbnail'
import getThumbnail2D from '@/components/ProductProfile/utils/getThumbnail2D'
import ImageComponent from '@/components/UiElements/ImageComponent'

import Form from '@/components/Form'
import { FilePreview } from '@/components/Form/types'


interface SelectTargetObjectProps {
	formData: any,
	onChange: (name: string, value: any) => void;
	updateForm: (itemName: string, attributeName: string, attributeValue: any) => void;
}


const TakeSnapshot: React.FC<SelectTargetObjectProps> = ({ formData, onChange }) => {

	const [thumbnail, setThumbnail] = React.useState<any>('')
	const [active, setActive] = React.useState<boolean>(false)



	const handleGetTargetObject = async () => {
		const threeViewer = (window as any).threeViewer
		setActive(true)

		if (threeViewer?.renderer) {
			// 3D path
			const canvas = threeViewer.renderer.domElement

			canvas.style.transition = 'opacity 0s ease-in-out'

			// A frame section is framed by its own normal; radialAngle means nothing to it and
			// would shoot the thumbnail from the product's front. Falls back for cylindrical
			// profiles and for a section that has no placement yet.
			const framed = await zoomToFrameSection(formData, true)
			if (!framed) await animateTo(formData.radialAngle, 0.005)
			canvas.style.opacity = 0.3
			setTimeout(() => {
				canvas.style.transition = 'opacity 0.2s ease-in-out'
				canvas.style.opacity = '1'
				setTimeout(() => {
					canvas.style.transition = 'opacity 0s ease-in-out'
					canvas.style.opacity = '1'
				}, 10)
			}, 200)

			const file = await getThumbnail()
			setThumbnail(file)
			onChange('thumbnail', file)
		} else {
			// 2D path — capture TwoDCanvas directly
			const file = await getThumbnail2D()
			setThumbnail(file)
			onChange('thumbnail', file)
		}

		setActive(false)
	}

	const handleSelectFile = (form :any) => {
		setThumbnail(form.file)
		onChange('thumbnail', form.file)
	}

	const handleRemoveTargetObject = () => {
		setThumbnail('')
		onChange('thumbnail', null)
	}

	useEffect(() => {
		if (formData.thumbnail?.string !== thumbnail?.string) {
			setThumbnail(formData.thumbnail || '')
		}
	}, [formData])


	return (
		<>

			<div className={'flex flex-row gap-xs'}>
				{!thumbnail ?
					<div className={"flex-row gap-xs flex flex-1"}>
						<Button onClick={handleGetTargetObject} className={`flex-1 inset-1 !justify-start !flex-row gap-md ${active ? '!border-primary-500 !shadow-focus' : ''} `} type={'alt'} disabled={active} icon={`${active ? '' : ''}`} iconClassName={active ? 'animate-spin' : ''}>
							<>

								<span>Take a Snapshot</span>
							</>
						</Button>
						<div className={"w-[44px] h-[44px] relative"}>
							<Form
								items={[
									{
										name: 'file',
										type: 'File',
										placeholder:'',
										itemOptions: {
											filePreview: (file: FilePreview) => (
												file.string ? <ImageComponent
													src={file.string}
													style={{ height: '70px', width: '70px' }}
													className="w-[70px] h-[70px]"
													id={file.uuid}
												/> : null
											),
											hint: ' ',
											acceptFormat: 'image/*, .avif, .webp, .svg, .png, .jpg, .jpeg',
										},
										classNames: {
											content: "font-icon-regular !h-[44px] !w-[44px]",
										}
									}
								]}
								onChange={handleSelectFile}

							/>
						</div>
						{/*<Button onClick={handleSelectFile} className={`!justify-center !flex-row gap-md ${active ? '!border-primary-500 !shadow-focus' : ''} `} type={'alt'} icon={``} disabled={active} />*/}
					</div>
					:
					<div className={'flex  items-center h-[90px]  flex-1 text-text-md text-gray-900 rounded-md border border-gray-300 bg-white shadow-xs select-none pl-md relative'}>
                        <span className={'flex-1 truncate'}>
                            <ImageComponent
								src={thumbnail.string}
								style={{ height: '70px', width: '70px' }}
								className="w-[70px] h-[70px]"
                            />
                        </span>
						<DeleteAbsoluteButton onClick={handleRemoveTargetObject} />
					</div>
				}

			</div>

		</>
	)
}

export default TakeSnapshot